let funny_memes = [
	'half_moon',
	'haha',
	'loud',
	'funnybear',
	'lol',
	'yeet',
	'dab',
	'owo',
	'xxvvcvc',
	'xxxvhbv',
	'qqqmnhw',
	'realisticguitarexperience',
	'guitarfreaks',
	'drummania',
	'gitadora',
	'nature',
	'honeypudding',
	'howtomaketastyriceandtheeffectsofeatingrice',
	'rockfansoftheworld',
	'getit',
	'tambourine',
	'bbone',
	'tbone',
	'qbone',
	'guitar',
	'supreme',
	'fanart',
	'450songs',
	'idontgethowpeoplelikethesesongsthedrummerjustspamstomsthroughoutthesongitsoundslikegarbagetherearesomecoolpartsbuttheyhardlyfollowthesong',
	'inmyopinionthissongissuchapieceofshitwheresthemusicwheresthegroovewheresthemelodyitscreatedfordifficultgameplayonlynotforaudiences',
	'gifted',
	'program',
	'badmanbad',
	'honeypudding',
	'rio',
	'kyoka',
	'gen',
	'otobear',
	'badlytunedpiano',
	'mystspeedrun',
	'rivenspeedrun',
	'over450songs'
];

export default function() {
	return funny_memes[Math.floor(Math.random()*funny_memes.length)];
}


// WEBPACK FOOTER //
// ./src/Dictionary.js